module.exports = __webpack_public_path__ + "static/img/TX.61a2764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/TX.png
// module id = vxuY
// module chunks = 34